/// <reference path="../../typings/tsd.d.ts" /> 
module Wars.Domain.Model {
    export class ProcessConfigurationUtilities {
        public static GetFields(form:Form):Field[] {
            var fields = [];
            if (form.mySteps) {
                for (var i = 0; i < form.mySteps.length; i++) {
                    if (form.mySteps[i].formSections) {
                        if (form.mySteps[i].formSections) {
                            for (var x = 0; x < form.mySteps[i].formSections.length; x++) {
                                if (form.mySteps[i].formSections[x].fields) {
                                    for (var y = 0; y < form.mySteps[i].formSections[x].fields.length; y++) {
                                        fields.push(form.mySteps[i].formSections[x].fields[y]);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            return fields;
        }

        public static GetFieldUniqueNames(form:Form): linqjs.IEnumerable<string> {
            var fields = Wars.Domain.Model.ProcessConfigurationUtilities.GetFields(form);
            return Enumerable.from(fields).select(f => f.schemaProperty.uniqueIdentifier);
        }
    }
} 